<script lang="ts" setup>
defineProps<{ title: string }>()
const emit = defineEmits(['close'])
</script>

<template>
  <div class="ui-modal-header flex justify-between items-start p-4 max-w-(--max-width) mx-auto w-full">
    <h1 class="text-2xl font-medium">{{ title }}</h1>
    <button @click="emit('close')" id="close-modal-button"
            class="bg-red-600 text-white cursor-pointer transition duration-300 uppercase hover:opacity-60 px-4 py-2 rounded">
      Close
    </button>
  </div>
</template>
